interface Props {
  password: string;
  onPassword: (value: string) => void;
  onSubmit: () => void;
  onCancel?: () => void;
  busy?: boolean;
  error?: string | null;
  hint?: string;
}

export default function AdminLoginForm({
  password,
  onPassword,
  onSubmit,
  onCancel,
  busy,
  error,
  hint,
}: Props) {
  return (
    <form
      className="w-full max-w-xs rounded-2xl border border-white/10 bg-ink-900/95 p-3 text-left"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">Admin-Login</div>
      {hint ? <p className="mt-1 text-[11px] text-slate-500">{hint}</p> : null}
      <input
        type="password"
        value={password}
        onChange={(e) => onPassword(e.target.value)}
        placeholder="Passwort"
        autoComplete="current-password"
        className="mt-2 min-h-touch w-full rounded-xl bg-ink-950 px-3 text-sm outline-none ring-amber-glow/40 focus:ring"
      />
      {error ? (
        <p role="alert" className="mt-2 text-sm font-bold text-crimson">
          {error}
        </p>
      ) : null}
      <div className="mt-2 flex gap-2">
        <button
          type="submit"
          disabled={busy || !password.trim()}
          className="min-h-touch flex-1 rounded-xl bg-ink-700 text-xs font-bold disabled:opacity-50"
        >
          Login
        </button>
        {onCancel ? (
          <button type="button" className="min-h-touch rounded-xl px-3 text-xs text-slate-500" onClick={onCancel}>
            Abbrechen
          </button>
        ) : null}
      </div>
    </form>
  );
}
